import React from 'react';
import { translate } from 'react-i18next';
import { NotificationTags , NotificationTagsKeys } from '../../../Enums/NotificationTags';
import { Table } from "rsuite";


const NotificationTagsTable = ({...props}) => {
    const { Column, HeaderCell, Cell } = Table;
    const { t: translate } = props;
    const t = (param) => translate(`workplanManager:settings.workflowNotifications.customTags.${param}`)

    const customTagsToTableData = Object.values(NotificationTags).map((tag) =>
        ({ customTag: t(`tags.${NotificationTagsKeys[tag]}`), customTagDetail: t(`tags.${NotificationTagsKeys[tag]}Details`) }));

    return (
        <Table data={customTagsToTableData} height={450} >
            <Column width={200} key={2}>
                <HeaderCell>{t('nameTableHeader')}</HeaderCell>
                <Cell dataKey="customTag"/>
            </Column>
            <Column width={500} key={1}>
                <HeaderCell>{t('detailTableHeader')}</HeaderCell>
                <Cell dataKey="customTagDetail"/>
            </Column>
        </Table>
    )
}

export default translate('workplanManager')(NotificationTagsTable);